export const gateway = "https://canary-greengardens-bms-api.link.wawanesalife.com";
export const LoginUrlParameter = "https://canary-brokers.auth.ca-central-1.amazoncognito.com/login?client_id=113ntcmpum0dfd1m92fgpq3tlb&response_type=token&scope=email+openid&redirect_uri=https%3A%2F%2Fcanary-greengardens-bms.link.wawanesalife.com%2Fredirect";
export const assets = "https://canary-assets.link.wawanesalife.com/brokers/wawanesalife";
export const HasLinkAdmin = "no";
export const BrokerPoolClientParameter = "113ntcmpum0dfd1m92fgpq3tlb";
export const BrokerPoolDomainParameter = "canary-brokers";
export const BrokerPoolParameter = "ca-central-1_kXVrTc3NQ";

export const TopMenuLink1Caption = "Wawanesa Life";
export const TopMenuLink1Url = "https://www.wawanesalife.com";
export const TopMenuLink2Caption = "QuickTerm quoter";
export const TopMenuLink2Url = "https://canary-greengardens-shopper.link.wawanesalife.com";

//updated on Tue May 13 2025 19:12:27 GMT+0000 (Coordinated Universal Time)
